import http from '@/plugins/axios/axios';

export default class ArquivoFolhaNasajonService {

    salvar(requisicao) {       
        return http.post('/api/documento/arquivo-folha-nasajon/salvar', requisicao);
    }

    listar(requisicao) {       
        return http.post('/api/documento/arquivo-folha-nasajon/listar', requisicao);
    } 
    
    exportarArquivoFolha(requisicao) {       
        return http.post('/api/documento/arquivo-folha-nasajon/folha-pag', requisicao, {responseType: 'blob'});
    } 
}